import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import analytics from '@react-native-firebase/analytics';

// Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyCKdKrW0RSQjMFIJ_iNg0YVwvBa9FIW0-c",
	authDomain: "gymbro-prod.firebaseapp.com",
	projectId: "gymbro-prod",
	storageBucket: "gymbro-prod.firebasestorage.app",
	messagingSenderId: "782922659166",
	appId: "1:782922659166:web:6a4a18a00d1ca8f58fcbcf",
	measurementId: "G-YZKBY5VM21" // Reemplaza con tu ID de medición de Google Analytics
};

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const firestore = getFirestore(app);
const storage = getStorage(app);

/**
 * Servicio de Analytics de Firebase
 */
class AnalyticsService {
	/**
	 * Inicializa la recolección de datos de Analytics
	 * @param enabled Si la recolección de datos está habilitada
	 */
	async setAnalyticsCollectionEnabled(enabled: boolean): Promise<void> {
		return analytics().setAnalyticsCollectionEnabled(enabled);
	}

	/**
	 * Obtiene el ID de instancia de la aplicación
	 * @returns El ID de instancia o null si no está disponible
	 */
	async getAppInstanceId(): Promise<string | null> {
		return analytics().getAppInstanceId();
	}

	/**
	 * Registra un evento personalizado en Analytics
	 * @param eventName Nombre del evento
	 * @param params Parámetros del evento
	 */
	async logEvent(eventName: string, params?: Record<string, any>): Promise<void> {
		return analytics().logEvent(eventName, params);
	}

	/**
	 * Establece el ID del usuario actual
	 * @param userId ID del usuario o null para eliminarlo
	 */
	async setUserId(userId: string | null): Promise<void> {
		return analytics().setUserId(userId);
	}

	/**
	 * Establece una propiedad de usuario
	 * @param name Nombre de la propiedad
	 * @param value Valor de la propiedad o null para eliminarla
	 */
	async setUserProperty(name: string, value: string | null): Promise<void> {
		return analytics().setUserProperty(name, value);
	}

	/**
	 * Registra un evento de vista de pantalla
	 * @param screenName Nombre de la pantalla
	 * @param screenClass Clase de la pantalla (opcional)
	 */
	async logScreenView(screenName: string, screenClass?: string): Promise<void> {
		return analytics().logScreenView({
			screen_name: screenName,
			screen_class: screenClass || screenName,
		});
	}

	/**
	 * Configura el consentimiento del usuario para Analytics
	 * @param settings Configuración de consentimiento
	 */
	async setConsent(settings: {
		analytics_storage?: boolean;
		ad_storage?: boolean;
		ad_user_data?: boolean;
		ad_personalization?: boolean;
	}): Promise<void> {
		return analytics().setConsent(settings);
	}

	/**
	 * Restablece los datos de Analytics
	 */
	async resetAnalyticsData(): Promise<void> {
		return analytics().resetAnalyticsData();
	}
}

// Exportar instancia del servicio de Analytics
const analyticsService = new AnalyticsService();

export { app, auth, firestore, storage, analyticsService };